// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
}

.venue-item {
  border-radius: 0;
  background: var(--background-color);
  box-shadow: 0px 0px 41.0307693481px 0px rgba(0, 0, 0, 0.0588235294);
  transition: 0.3s linear;
  text-align: left;
  margin-bottom: 20px;
  overflow: auto;
}
@media (max-width: 500px) {
  .venue-item {
    max-height: 65vh;
    margin-top: auto;
    margin: 0px 10px;
  }
}
.venue-item.selected {
  transition: 0.3s linear;
  background: white;
  color: white;
}
.venue-item p {
  margin: 0;
}
.venue-item .name {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 19px;
  text-align: left;
  margin-bottom: 1px;
  color: #000;
  text-transform: uppercase;
}
.venue-item .address {
  font-family: AppFont, sans-serif;
  font-size: 12px;
  line-height: 15px;
  text-align: left;
  color: black;
}

.right-col {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.info-block {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.info-block .icon {
  height: 22px;
  width: 22px;
  cursor: pointer;
}
.info-block .icon:first-child {
  margin-right: 3.5px;
}
.info-block .icon ion-icon {
  width: 100%;
  height: 100%;
}

.open-block {
  display: flex;
  justify-content: flex-end;
  padding-top: 5px;
}
.open-block .label-open {
  width: 120px;
  height: 25px;
  padding-inline: 5px;
  border-radius: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #db052c;
  color: white;
  font-family: AppFont, sans-serif;
  font-size: 9px;
  line-height: 10px;
  text-align: center;
}
.open-block .label-open ion-label {
  color: white;
  font-family: AppFontLight, sans-serif;
  font-size: 9px;
  line-height: 10px;
  text-align: center;
  text-wrap: auto;
  text-align: center;
}
.open-block .label-open.enabled {
  background-color: #10843e;
}

.distance {
  height: 21px;
  min-width: 45px;
  padding: 2px 8px !important;
  text-align: center;
  margin-right: 5px;
}

.second-row {
  margin-top: 2px;
}

.app-logo {
  width: 60px;
  height: 35px;
  color: var(--ion-color-gold);
}
.app-logo.selected {
  color: white;
}

.wrap {
  padding-top: 10px;
}

a {
  height: 21px;
}

.box {
  color: var(--ion-color-main);
  border: 2px solid var(--ion-color-main);
  padding: 2px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}
.box.selected {
  color: white;
  border: 2px solid white;
}

.venue-status {
  color: white;
  background: var(--ion-color-gold);
  border-radius: 2px;
  font-size: 13px;
  width: -moz-fit-content;
  width: fit-content;
  padding: 2px 8px !important;
  min-width: 45px;
  text-align: center;
  margin-right: 5px;
}
.venue-status.selected {
  background: white;
  color: var(--ion-color-primary);
}

.preorder-type {
  --background: #f6f0eb;
  color: #9f9f9f;
  font-weight: bold;
  cursor: pointer;
  --padding: 16px;
  border-radius: 0;
  border: none !important;
  padding: 0;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  margin: 0;
  --detail-icon-color: var(--ion-color-main);
  --detail-icon-opacity: 1;
}
.preorder-type.active {
  transition: 0.3s linear;
  --background: #f6f0eb;
  color: var(--ion-color-main);
}
.preorder-type h3 {
  font-family: AppFont-black, sans-serif;
  font-size: 14px;
}
.preorder-type p {
  color: var(--ion-color-primary);
  font-weight: 400;
}

.border-top {
  border-top: 0.5px solid #e8e8e8;
}

.align-center {
  text-align: center;
}

.button-separator {
  width: 3px;
  height: 100%;
}

.top-row {
  padding: 6px;
  min-height: 63px;
  position: relative;
}

.arrow-wrapper {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  height: 14px;
  width: 18px;
  cursor: pointer;
  z-index: 10;
}

.arrow-down {
  height: 100%;
  width: 100%;
  transition: opacity 0.3s ease-out;
}

.venue-item:has(.type_show) .arrow-wrapper {
  opacity: 0;
  pointer-events: none;
}
.venue-item:has(.type_show) .separator--top {
  opacity: 0;
  margin: 0;
}

.small-margin-top {
  margin-top: 6px;
}

.top-end-img {
  position: absolute;
  top: 0;
  right: 0;
  height: 36px;
  width: 40px;
}

.type-col {
  padding: 11px;
}

.delivery-col {
  padding: 5px 11px 23px;
}

.item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;
}
.item .item-left-part {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.item .type-icon {
  height: 100%;
  margin-right: 8px;
  opacity: 0.3;
  transition: opacity 2s;
}
.item .item-info {
  width: 80%;
}
.item .item-type {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  color: var(--ion-color-primary);
  opacity: 0.3;
  transition: opacity 2s;
  text-transform: uppercase;
}
.item .item-desc {
  font-family: AppFont;
  font-size: 11px;
  line-height: 13px;
  text-align: left;
  color: #000;
  opacity: 0.3;
  transition: opacity 2s;
}
.item .item-arrow {
  height: 100%;
  opacity: 0.3;
  transition: opacity 2s;
}
.item.active .type-icon {
  opacity: 1;
}
.item.active .item-arrow {
  opacity: 1;
}
.item.active .item-type {
  opacity: 1;
}
.item.active .item-type .item-desc {
  opacity: 1;
}

.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: opacity 0.3s ease-out, margin 0.5s ease-out;
}
.separator--top {
  margin-top: 15px;
  margin-bottom: 5px;
}
.separator .line {
  height: 8px;
  background-image: url('dot.svg');
  background-size: 7px 100%;
}

.delivery-col {
  position: relative;
}
.delivery-col .title-block {
  margin-bottom: 16px;
}
.delivery-col .title {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  color: #000;
  text-transform: uppercase;
}
.delivery-col .subtitle {
  font-family: AppFontLight;
  font-size: 11px;
  line-height: 13px;
  text-align: left;
}
.delivery-col .delivery-items-container {
  display: flex;
  gap: 6px;
}
.delivery-col .delivery-item {
  border: 0.3px solid #787777;
  height: 48px;
  flex: 1;
  max-width: calc(33.333% - 6px);
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 8px;
  opacity: 0.5;
  transition: all 0.3s ease;
}
@media (max-width: 480px) {
  .delivery-col .delivery-item {
    height: 44px;
    padding: 6px;
  }
}
.delivery-col .delivery-item.active {
  cursor: pointer;
  opacity: 1;
  border-color: #787777;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.delivery-col .delivery-item.active:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.delivery-col .delivery-item .item-arrow {
  display: none;
}
.delivery-col .delivery-item ion-img:not(.item-arrow) {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.delivery-col .arrow-up-wrapper {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  height: 6px;
  width: 10px;
  cursor: pointer;
  z-index: 10;
}
.delivery-col .arrow-up {
  height: 100%;
  width: 100%;
  transform: rotate(180deg);
}

.type-wrapper {
  height: -moz-fit-content;
  height: fit-content;
  max-height: 0px;
  transition: max-height 1s;
  overflow: auto;
}
.type-wrapper.type_show {
  max-height: 800px;
}

.distance-block {
  padding-top: 5px;
  font-size: 10px;
  color: #000;
  font-family: AppFontLight, sans-serif;
  text-align: right;
}

.time-open {
  padding-top: 5px;
  font-size: 10px;
}
.time-open span {
  font-family: AppFontBold;
  color: var(--ion-color-black);
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/app/components/venue-suggestion/venue-suggestion.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;AACD;;AACA;EACC,gBAAA;EACA,mCAAA;EACA,mEAAA;EAEA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AACD;AAAC;EATD;IAUE,gBAAA;IACA,gBAAA;IACA,gBAAA;EAGA;AACF;AADC;EACC,uBAAA;EACA,iBAAA;EAEA,YAAA;AAEF;AACC;EACC,SAAA;AACF;AAEC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;AAAF;AAGC;EACC,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,YAAA;AAFF;;AAMA;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;AAHD;;AAMA;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAHD;AAKC;EACC,YAAA;EACA,WAAA;EACA,eAAA;AAHF;AAKE;EACC,mBAAA;AAHH;AAKE;EACC,WAAA;EACA,YAAA;AAHH;;AAOA;EACC,aAAA;EACA,yBAAA;EACA,gBAAA;AAJD;AAKC;EACC,YAAA;EACA,YAAA;EACA,mBAAA;EAEA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,gCAAA;EACA,cAAA;EACA,iBAAA;EAEA,kBAAA;AALF;AAME;EACC,YAAA;EACA,qCAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAJH;AAME;EACC,yBAAA;AAJH;;AASA;EACC,YAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;AAND;;AASA;EACC,eAAA;AAND;;AASA;EACC,WAAA;EACA,YAAA;EACA,4BAAA;AAND;AAQC;EACC,YAAA;AANF;;AAUA;EACC,iBAAA;AAPD;;AAUA;EACC,YAAA;AAPD;;AAUA;EACC,4BAAA;EACA,uCAAA;EACA,YAAA;EACA,0CAAA;AAPD;AASC;EACC,YAAA;EACA,uBAAA;AAPF;;AAWA;EACC,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AARD;AAUC;EACC,iBAAA;EACA,+BAAA;AARF;;AAYA;EACC,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,wCAAA;EACA,SAAA;EACA,0CAAA;EACA,wBAAA;AATD;AAWC;EACC,uBAAA;EACA,qBAAA;EACA,4BAAA;AATF;AAYC;EACC,sCAAA;EACA,eAAA;AAVF;AAaC;EACC,+BAAA;EACA,gBAAA;AAXF;;AAeA;EACC,+BAAA;AAZD;;AAeA;EACC,kBAAA;AAZD;;AAeA;EACC,UAAA;EACA,YAAA;AAZD;;AAeA;EACC,YAAA;EACA,gBAAA;EACA,kBAAA;AAZD;;AAeA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AAZD;;AAeA;EACC,YAAA;EACA,WAAA;EACA,iCAAA;AAZD;;AAgBC;EACC,UAAA;EACA,oBAAA;AAbF;AAgBC;EACC,UAAA;EACA,SAAA;AAdF;;AAkBA;EACC,eAAA;AAfD;;AAkBA;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AAfD;;AAkBA;EACC,aAAA;AAfD;;AAkBA;EACC,sBAAA;AAfD;;AAkBA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EAEA,eAAA;AAhBD;AAiBC;EACC,YAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AAfF;AAkBC;EACC,YAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AAhBF;AAmBC;EACC,UAAA;AAjBF;AAoBC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,+BAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;AAnBF;AAsBC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AArBF;AAwBC;EACC,YAAA;EACA,YAAA;EACA,sBAAA;AAtBF;AA0BE;EACC,UAAA;AAxBH;AA0BE;EACC,UAAA;AAxBH;AA0BE;EACC,UAAA;AAxBH;AA0BG;EACC,UAAA;AAxBJ;;AA8BA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uDAAA;AA3BD;AA6BC;EACC,gBAAA;EACA,kBAAA;AA3BF;AA8BC;EACC,WAAA;EACA,gCAAA;EACA,yBAAA;AA5BF;;AAgCA;EACC,kBAAA;AA7BD;AA8BC;EACC,mBAAA;AA5BF;AA8BC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;EACA,yBAAA;AA7BF;AA+BC;EACC,yBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;AA9BF;AAiCC;EACO,aAAA;EACA,QAAA;AA/BR;AAkCC;EACK,2BAAA;EACA,YAAA;EACA,OAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;AAhCN;AAkCM;EAbL;IAcO,YAAA;IACA,YAAA;EA/BN;AACF;AAiCM;EACE,eAAA;EACA,UAAA;EACA,qBAAA;EACA,wCAAA;AA/BR;AAiCQ;EACE,2BAAA;EACA,yCAAA;AA/BV;AAmCM;EACE,aAAA;AAjCR;AAoCM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAlCR;AAsCC;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AApCF;AAuCC;EACC,YAAA;EACA,WAAA;EACA,yBAAA;AArCF;;AAwCA;EACC,wBAAA;EAAA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AArCD;AAsCC;EACC,iBAAA;AApCF;;AAwCA;EACC,gBAAA;EACA,eAAA;EACA,WAAA;EACA,qCAAA;EACA,iBAAA;AArCD;;AAuCA;EACC,gBAAA;EACA,eAAA;AApCD;AAqCC;EACC,wBAAA;EACA,6BAAA;EACA,iBAAA;AAnCF","sourcesContent":[":host {\n\tdisplay: flex;\n}\n.venue-item {\n\tborder-radius: 0;\n\tbackground: var(--background-color);\n\tbox-shadow: 0px 0px 41.03076934814453px 0px #0000000f;\n\n\ttransition: 0.3s linear;\n\ttext-align: left;\n\tmargin-bottom: 20px;\n\toverflow: auto;\n\t@media (max-width: 500px) {\n\t\tmax-height: 65vh;\n\t\tmargin-top: auto;\n\t\tmargin: 0px 10px;\n\t}\n\n\t&.selected {\n\t\ttransition: 0.3s linear;\n\t\tbackground: white;\n\n\t\tcolor: white;\n\t}\n\n\tp {\n\t\tmargin: 0;\n\t}\n\n\t.name {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 16px;\n\t\tline-height: 19px;\n\t\ttext-align: left;\n\t\tmargin-bottom: 1px;\n\t\tcolor: #000;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.address {\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-size: 12px;\n\t\tline-height: 15px;\n\t\ttext-align: left;\n\n\t\tcolor: black;\n\t}\n}\n\n.right-col {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n}\n\n.info-block {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n\n\t.icon {\n\t\theight: 22px;\n\t\twidth: 22px;\n\t\tcursor: pointer;\n\n\t\t&:first-child {\n\t\t\tmargin-right: 3.5px;\n\t\t}\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t}\n\t}\n}\n.open-block {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tpadding-top: 5px;\n\t.label-open {\n\t\twidth: 120px;\n\t\theight: 25px;\n\t\tpadding-inline: 5px;\n\n\t\tborder-radius: 45px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground-color: #db052c;\n\t\tcolor: white;\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-size: 9px;\n\t\tline-height: 10px;\n\n\t\ttext-align: center;\n\t\tion-label {\n\t\t\tcolor: white;\n\t\t\tfont-family: AppFontLight, sans-serif;\n\t\t\tfont-size: 9px;\n\t\t\tline-height: 10px;\n\t\t\ttext-align: center;\n\t\t\ttext-wrap: auto;\n\t\t\ttext-align: center;\n\t\t}\n\t\t&.enabled {\n\t\t\tbackground-color: #10843e;\n\t\t}\n\t}\n}\n\n.distance {\n\theight: 21px;\n\tmin-width: 45px;\n\tpadding: 2px 8px !important;\n\ttext-align: center;\n\tmargin-right: 5px;\n}\n\n.second-row {\n\tmargin-top: 2px;\n}\n\n.app-logo {\n\twidth: 60px;\n\theight: 35px;\n\tcolor: var(--ion-color-gold);\n\n\t&.selected {\n\t\tcolor: white;\n\t}\n}\n\n.wrap {\n\tpadding-top: 10px;\n}\n\na {\n\theight: 21px;\n}\n\n.box {\n\tcolor: var(--ion-color-main);\n\tborder: 2px solid var(--ion-color-main);\n\tpadding: 2px;\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n\n\t&.selected {\n\t\tcolor: white;\n\t\tborder: 2px solid white;\n\t}\n}\n\n.venue-status {\n\tcolor: white;\n\tbackground: var(--ion-color-gold);\n\tborder-radius: 2px;\n\tfont-size: 13px;\n\twidth: fit-content;\n\tpadding: 2px 8px !important;\n\tmin-width: 45px;\n\ttext-align: center;\n\tmargin-right: 5px;\n\n\t&.selected {\n\t\tbackground: white;\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n\n.preorder-type {\n\t--background: #f6f0eb;\n\tcolor: #9f9f9f;\n\tfont-weight: bold;\n\tcursor: pointer;\n\t--padding: 16px;\n\tborder-radius: 0;\n\tborder: none !important;\n\tpadding: 0;\n\tbox-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n\tmargin: 0;\n\t--detail-icon-color: var(--ion-color-main);\n\t--detail-icon-opacity: 1;\n\n\t&.active {\n\t\ttransition: 0.3s linear;\n\t\t--background: #f6f0eb;\n\t\tcolor: var(--ion-color-main);\n\t}\n\n\th3 {\n\t\tfont-family: AppFont-black, sans-serif;\n\t\tfont-size: 14px;\n\t}\n\n\tp {\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-weight: 400;\n\t}\n}\n\n.border-top {\n\tborder-top: 0.5px solid #e8e8e8;\n}\n\n.align-center {\n\ttext-align: center;\n}\n\n.button-separator {\n\twidth: 3px;\n\theight: 100%;\n}\n\n.top-row {\n\tpadding: 6px;\n\tmin-height: 63px;\n\tposition: relative;\n}\n\n.arrow-wrapper {\n\tposition: absolute;\n\tbottom: 35px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\theight: 14px;\n\twidth: 18px;\n\tcursor: pointer;\n\tz-index: 10;\n}\n\n.arrow-down {\n\theight: 100%;\n\twidth: 100%;\n\ttransition: opacity 0.3s ease-out;\n}\n\n.venue-item:has(.type_show) {\n\t.arrow-wrapper {\n\t\topacity: 0;\n\t\tpointer-events: none;\n\t}\n\n\t.separator--top {\n\t\topacity: 0;\n\t\tmargin: 0;\n\t}\n}\n\n.small-margin-top {\n\tmargin-top: 6px;\n}\n\n.top-end-img {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\theight: 36px;\n\twidth: 40px;\n}\n\n.type-col {\n\tpadding: 11px;\n}\n\n.delivery-col {\n\tpadding: 5px 11px 23px;\n}\n\n.item {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: 16px;\n\n\tcursor: pointer;\n\t.item-left-part {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t}\n\n\t.type-icon {\n\t\theight: 100%;\n\t\tmargin-right: 8px;\n\t\topacity: 0.3;\n\t\ttransition: opacity 2s;\n\t}\n\n\t.item-info {\n\t\twidth: 80%;\n\t}\n\n\t.item-type {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\n\t\ttext-align: left;\n\t\tcolor: var(--ion-color-primary);\n\t\topacity: 0.3;\n\t\ttransition: opacity 2s;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.item-desc {\n\t\tfont-family: AppFont;\n\t\tfont-size: 11px;\n\t\tline-height: 13px;\n\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\topacity: 0.3;\n\t\ttransition: opacity 2s;\n\t}\n\n\t.item-arrow {\n\t\theight: 100%;\n\t\topacity: 0.3;\n\t\ttransition: opacity 2s;\n\t}\n\n\t&.active {\n\t\t.type-icon {\n\t\t\topacity: 1;\n\t\t}\n\t\t.item-arrow {\n\t\t\topacity: 1;\n\t\t}\n\t\t.item-type {\n\t\t\topacity: 1;\n\n\t\t\t.item-desc {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.separator {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\ttransition: opacity 0.3s ease-out, margin 0.5s ease-out;\n\n\t&--top {\n\t\tmargin-top: 15px;\n\t\tmargin-bottom: 5px;\n\t}\n\n\t.line {\n\t\theight: 8px;\n\t\tbackground-image: url(../../../assets/losteria/dot.svg);\n\t\tbackground-size: 7px 100%;\n\t}\n}\n\n.delivery-col {\n\tposition: relative;\n\t.title-block {\n\t\tmargin-bottom: 16px;\n\t}\n\t.title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\ttext-transform: uppercase;\n\t}\n\t.subtitle {\n\t\tfont-family: AppFontLight;\n\t\tfont-size: 11px;\n\t\tline-height: 13px;\n\n\t\ttext-align: left;\n\t}\n\n\t.delivery-items-container {\n        display: flex;\n        gap: 6px;\n\t}\n\n\t.delivery-item {\n      border: 0.3px solid #787777;\n      height: 48px;\n      flex: 1;\n      max-width: calc(33.333% - 6px);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background: white;\n      padding: 8px;\n      opacity: 0.5;\n      transition: all 0.3s ease;\n\n      @media (max-width: 480px) {\n        height: 44px;\n        padding: 6px;\n      }\n\n      &.active {\n        cursor: pointer;\n        opacity: 1;\n        border-color: #787777;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n        &:hover {\n          transform: translateY(-1px);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n        }\n      }\n\n      .item-arrow {\n        display: none;\n      }\n\n      ion-img:not(.item-arrow) {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n      }\n\t}\n\n\t.arrow-up-wrapper {\n\t\tposition: absolute;\n\t\tbottom: 10px;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\theight: 6px;\n\t\twidth: 10px;\n\t\tcursor: pointer;\n\t\tz-index: 10;\n\t}\n\n\t.arrow-up {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\ttransform: rotate(180deg);\n\t}\n}\n.type-wrapper {\n\theight: fit-content;\n\tmax-height: 0px;\n\ttransition: max-height 1s;\n\toverflow: auto;\n\t&.type_show {\n\t\tmax-height: 800px;\n\t}\n}\n\n.distance-block {\n\tpadding-top: 5px;\n\tfont-size: 10px;\n\tcolor: #000;\n\tfont-family: AppFontLight, sans-serif;\n\ttext-align: right;\n}\n.time-open {\n\tpadding-top: 5px;\n\tfont-size: 10px;\n\tspan {\n\t\tfont-family: AppFontBold;\n\t\tcolor: var(--ion-color-black);\n\t\ttext-align: right;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
